import { Modal } from "antd";
import React from "react";
import ArchiveCard from "../../workers/workers-details/worker-details-modals/WorkerArchiveCard";
import SubjectsForm from "../subjects-form/SubjectsForm";
import SubjectTransform from "../subject-trans-form/SubjectTransForm";
import { Subject } from "@src/redux/index";
import SubjectArchiveCard from "../subject-details-card/SubjectArchiveCard";
import SubjectUnArchiveCard from "../subject-details-card/SubjectUnArchiveCard";

interface SubjectsFormModalProps {
  formType:
    | "subject_archive"
    | "edit_subject"
    | "transferSubject"
    | "subject_un_archive";
  visible: boolean;
  onCancel: () => void;
  title: string;
  mutationType?: "edit" | "add";
  setModalVisible?: (visible: boolean) => void;
  subject?: Subject;
  worker?: any;
}

const SubjectsFormModal: React.FC<SubjectsFormModalProps> = (props) => {
  const {
    formType,
    visible,
    onCancel,
    title,
    mutationType,
    subject,
    worker,
  } = props;

  const renderFormContent = () => {
    switch (formType) {
      case "subject_archive":
        return (
          <SubjectArchiveCard
            name={subject?.name || "Unknown Subject"} // Provide a default value
            onCancel={onCancel}
            worker={subject}
          />
        );
      case "subject_un_archive":
        return (
          <SubjectUnArchiveCard
            name={subject?.name || "Unknown Subject"} // Provide a default value
            onCancel={onCancel}
            worker={subject}
          />
        );
      case "edit_subject":
        return (
          <SubjectsForm
            handleCancel={onCancel}
            mutationType={mutationType || "edit"}
            subject={subject}
          />
        );
      case "transferSubject":
        return <SubjectTransform onCancel={onCancel} subject={subject} />;
      default:
        return null;
    }
  };

  return (
    <Modal
      title={<span className="dynamic-modal">{title}</span>}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      {renderFormContent()}
    </Modal>
  );
};

export default SubjectsFormModal;
